import { Link, TableCell, TableRow } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import ExpandableText from "src/common/ExpandableText";
import TableActions from "src/common/TableActions";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { getFormattedCurrency } from "src/Helpers/utils";
import { useValidImage } from "src/hooks/useValidImage";
import { getStatusLabel } from "src/Utils/Combined";
import EditProduct from "./EditProduct";
import type { IExhibitorProduct } from "./products.type";

type IProps = {
	product: IExhibitorProduct;
	serial: number;
	paginationSkip: number;
};

const ProductRow = ({ product, serial, paginationSkip }: IProps) => {
	const [openModal, setOpenModal] = useState(false);
	const [productStatus, setProductStatus] = useState(
		product.user_fair_member_product_status
	);

	const imgSrc = useValidImage(product?.fair_member_product_photo);

	return (
		<>
			<TableRow hover>
				<TableCell>{serial + Number(paginationSkip)}</TableCell>

				<TableCell>
					<Box display="flex" alignItems="center" gap={2}>
						<Box
							component="img"
							src={imgSrc[0]}
							alt={product.fair_member_product_name}
							sx={{
								width: 48,
								height: 48,
								objectFit: "cover",
								textOverflow: "ellipsis",
								borderRadius: "50%",
							}}
						/>
						<Box component="span">
							{product.fair_member_product_name}
						</Box>
					</Box>
				</TableCell>
				<TableCell>
					{product.fair_member_product_url ? (
						<Link
							target="_blank"
							href={product.fair_member_product_url}
						>
							Visit Now
						</Link>
					) : (
						"N/A"
					)}
				</TableCell>
				<TableCell>{product.fair_member_product_category}</TableCell>
				<TableCell>
					{getStatusLabel(product.user_fair_member_product_status)}
				</TableCell>
				<TableCell>
					{getFormattedCurrency(product.fair_member_product_price)}
				</TableCell>
				<TableCell>
					{getFormattedCurrency(
						product.fair_member_special_product_price
					)}
				</TableCell>
				<TableCell>
					<ExpandableText
						text={product.fair_member_product_description}
					/>
				</TableCell>

				<TableActions
					showEdit
					handleEditFun={() => setOpenModal(true)}
				/>
			</TableRow>

			<ModalsWrapper
				showModal={openModal}
				setShowModal={setOpenModal}
				modalData={{ title: "Update Product Status" }}
				maxWidth="xs"
			>
				<>
					<EditProduct
						id={product.fair_member_product_id}
						status={productStatus}
						setProductStatus={setProductStatus}
						closeModal={() => setOpenModal(false)}
					/>
				</>
			</ModalsWrapper>
		</>
	);
};

export default ProductRow;
